/**
 * @generated SignedSource<<054a9a3dde27fe85822ec8e560eeca94>>
 * @relayHash ced5dde2cda9f3315b7dd277971b1b73
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ced5dde2cda9f3315b7dd277971b1b73

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type IcdCodesSearchType = "ALLERGY" | "CONDITION" | "EPISODE_OF_CARE";
export type useIcdDiagnosisQuery$variables = {
  birthDay?: any | null;
  excludedIcdCodes: ReadonlyArray<string>;
  gender?: Gender | null;
  searchText: string;
  searchType: IcdCodesSearchType;
};
export type useIcdDiagnosisQuery$data = {
  readonly icdDiagnosisSearch: {
    readonly commons: ReadonlyArray<{
      readonly entry: {
        readonly diagnosisCode: string;
        readonly id: string;
        readonly primaryCode: string | null;
        readonly text: string;
        readonly " $fragmentSpreads": FragmentRefs<"IcdDiagnosisFragment">;
      };
      readonly highlights: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }>;
    }>;
    readonly others: ReadonlyArray<{
      readonly entry: {
        readonly diagnosisCode: string;
        readonly id: string;
        readonly primaryCode: string | null;
        readonly text: string;
        readonly " $fragmentSpreads": FragmentRefs<"IcdDiagnosisFragment">;
      };
      readonly highlights: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }>;
    }>;
  };
};
export type useIcdDiagnosisQuery = {
  response: useIcdDiagnosisQuery$data;
  variables: useIcdDiagnosisQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "birthDay"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludedIcdCodes"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "gender"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchText"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchType"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "birthDay",
        "variableName": "birthDay"
      },
      {
        "kind": "Variable",
        "name": "excludedIcdCodes",
        "variableName": "excludedIcdCodes"
      },
      {
        "kind": "Variable",
        "name": "gender",
        "variableName": "gender"
      },
      {
        "kind": "Variable",
        "name": "searchText",
        "variableName": "searchText"
      },
      {
        "kind": "Variable",
        "name": "searchType",
        "variableName": "searchType"
      },
      {
        "kind": "Literal",
        "name": "top",
        "value": 50
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyValuePairOfStringAndString",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryCode",
  "storageKey": null
},
v11 = [
  (v6/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IcdDiagnosis",
    "kind": "LinkedField",
    "name": "entry",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IcdDiagnosisFragment"
      }
    ],
    "storageKey": null
  }
],
v12 = [
  (v6/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IcdDiagnosis",
    "kind": "LinkedField",
    "name": "entry",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAssociation",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secondaryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "associationType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IcdDiagnosis",
        "kind": "LinkedField",
        "name": "linkedConditionIcdDiagnosis",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useIcdDiagnosisQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "IcdDiagnosesOutput",
        "kind": "LinkedField",
        "name": "icdDiagnosisSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchIcdDiagnosis",
            "kind": "LinkedField",
            "name": "commons",
            "plural": true,
            "selections": (v11/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchIcdDiagnosis",
            "kind": "LinkedField",
            "name": "others",
            "plural": true,
            "selections": (v11/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useIcdDiagnosisQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "IcdDiagnosesOutput",
        "kind": "LinkedField",
        "name": "icdDiagnosisSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchIcdDiagnosis",
            "kind": "LinkedField",
            "name": "commons",
            "plural": true,
            "selections": (v12/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchIcdDiagnosis",
            "kind": "LinkedField",
            "name": "others",
            "plural": true,
            "selections": (v12/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ced5dde2cda9f3315b7dd277971b1b73",
    "metadata": {},
    "name": "useIcdDiagnosisQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9eeee405e74e95215e18fdcb8cdf4f2f";

export default node;
